import { ImageAd as ImageAdModel } from 'models/ImageAd';
import { ColumnLayout, ColumnType, ColumnCount } from '../Shared/Layout/columnLayout';
import { Ad } from 'components/Ad';

interface OwnProps {
  ads: ImageAdModel[];
  columns?: ColumnType;
}

const ImageAds = ({ ads, columns = ColumnCount.Three }: OwnProps) => {
  return (
    <ColumnLayout gutters columns={columns}>
      {ads && ads.map(ad => <Ad ad={ad} key={ad.ticket} />)}
    </ColumnLayout>
  );
};

export default ImageAds;
